import { render, staticRenderFns } from "./ZipCodeBox.vue?vue&type=template&id=2f5675e8&scoped=true&"
import script from "./ZipCodeBox.vue?vue&type=script&lang=js&"
export * from "./ZipCodeBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5675e8",
  null
  
)

export default component.exports